const resolveAlternativeLanguageCodes = ({ raw }: any) => {
  return raw?.alternative_lang_code ? JSON.parse(raw?.alternative_lang_code) : {};
};

export default resolveAlternativeLanguageCodes;
